import {EventModel} from "@shop/frontend/web/js/models/EventModel";

export class EventInteractPlanModel extends EventModel {
	constructor() {
		super();

		this.prices = [];
	}
}
